export default {
    namespaced: true,
    state: {
        classes: [],
    },
    getters: {
        getAll(state) {
            return state.classes;
        },
    },
    mutations: {
        setAll(state, classes) {
            Object.assign(state, {
                classes,
            });
        },
    },
    actions: {
        async fetchAll(context) {
            const classes = await context.dispatch('api/request', {
                service: 'class',
                type: 'getAll',
            }, { root: true });

            if (classes) {
                context.commit('setAll', classes);
            }
        },
        async updateFicBic(context, { id, fic_brand_id, bic_brand_id, bic_from} = {}) {
            const data = {
                id, fic_brand_id, bic_brand_id, bic_from,
            };

            return context.dispatch('api/request', {
                service: 'class',
                type: 'updateFicBic',
                data,
            }, { root: true });
        },
        async resetFicBic(context, { id, reset } = {}) {
            const data = {
                id, reset,
            };

            return context.dispatch('api/request', {
                service: 'class',
                type: 'resetFicBic',
                data,
            }, { root: true });
        },
    },
};
